import './ConfigurationModule.css';
import { useTranslation } from 'react-i18next'; // Importa o hook de tradu��o
import { useState, useEffect, useContext, useCallback, useRef, useMemo } from 'react';
import Modelos from '../../../components/Modelos';
import TpfSlider from '../../../components/TpfSlider/TpfSlider';
// GeneralFileList removed per request
import Info from '../../../components/Info';
import IconLibrary from './IconLibrary';
import SecondBox from '../../../components/SecondBox';
import ConfirmDeleteModal2 from '../../../components/DeletAssitant';
import { loadIcons } from "../../../utils/icons"; // Importa os �cones
import { formatAssistantData } from '../../../utils/formatAssistantData';
import { translateBackendError } from '../../../utils/translateBackendError';
import { addPendingUpload, listPendingUploads, pollJobStatus, removePendingUpload } from '../../../utils/selfAssistantUploadJobs';
import { AuthContext } from '../../../authContext';
import AlertsCustom from '../../../components/Alerts/index';
import FileUpload from '../../../components/FileUpload/index';
import ToggleSwitch from '../../../components/ToggleSwitch';
import OneDriveFileButton from '../../../components/OneDriveFileButton'
import ReloadFolderButton from '../../../components/ReloadFolderButton'
import ConfigurationTabs from '../../../components/ConfigurationTabs';
import AddUsersButton from '../../../components/AddUsersButton';
import InputAdcWrapper from '../../../components/InputAdcWrapper';
import InputAddByEmail from '../../../components/InputAddByEmail';
import LocalClusterConfig from '../../../components/LocalClusterConfig';
import N8nToolsConfig from '../../../components/N8nToolsConfig';
import SkillsTab from './SkillsTab';


function ConfigurationModule({ classeCSS, model, setModel, email, setAssistantId, assistantId, assistant, setAssistant, svgPath, isNewCreated, setIsNewCreated, documentList, setDocumentList, users, setUsers, status, setStatus, handleUpdate, handleCapabilitiesUpdate, validationErrors, showInstructionPanel, setShowInstructionPanel, showValidationErrors, triggerValidation, storageUsage, onCreateSkill }) {

    const { t: tSelfAssist } = useTranslation('assistantConfiguration');
    const { t: tCommon } = useTranslation('common');
    const icons = loadIcons(); // Carrega oscones dinamicamente
    const [currentIndex, setCurrentIndex] = useState(0); //Índice para o carrossel
    const [activeIcon, setActiveIcon] = useState(null); // Estado para rastrear o �cone ativo
    // Estado para controlar a aba ativa da barra de navega��o
    // valores: 'personalizacao' | 'configuracoes' | 'gestao'
    const [activeTab, setActiveTab] = useState('personalizacao');
    // upload-related state removed (Upload button was removed)
    // Show advanced settings by default (we removed the on/off toggle and replaced it with a 'Restore' button)
    const [showAdvanced, setShowAdvanced] = useState(true);
    const { accessToken, resourceGroup, level, setAssistantList } = useContext(AuthContext);
    const canConfigureLocalCluster = level === 'dev';
    const [alert, setAlert] = useState({ title: '', type: '', message: '', open: false });
    const [uploadingFilesList, setUploadingFilesList] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [showSaveButton, setShowSaveButton] = useState(true);
    const [showAddUsersPanel, setShowAddUsersPanel] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [allowedDomains, setAllowedDomains] = useState([]);
    const [searchTermWithAccess, setSearchTermWithAccess] = useState("");
    const [searchTermWithoutAccess, setSearchTermWithoutAccess] = useState("");
    const [emailToAdd, setEmailToAdd] = useState('');
    const emailInputRef = useRef(null);
    const isCreatingRef = useRef(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    //const assistantId = assistant?._id;
    const { t: tChat } = useTranslation('chat');
    const [canUseOneDrive, setCanUseOneDrive] = useState(false);
    const [canUseN8n, setCanUseN8n] = useState(false);
    const [triedUpload, setTriedUpload] = useState(false);
    // Falso apos desmontar: o acompanhamento de upload para de consultar e deixa a
    // pendencia guardada (utils/selfAssistantUploadJobs.js) para a proxima montagem retomar.
    const mountedRef = useRef(true);
    const reconciledAssistantRef = useRef(null);
    useEffect(() => {
        mountedRef.current = true;
        return () => { mountedRef.current = false; };
    }, []);

    const rawAssistantName = assistant?.assistant?.name ?? '';
    const trimmedAssistantName = typeof rawAssistantName === 'string' ? rawAssistantName.trim() : '';
    const assistantDescriptionValue = assistant?.assistant?.description;
    const normalizedAssistantDescription = Array.isArray(assistantDescriptionValue)
        ? assistantDescriptionValue[0] ?? ''
        : assistantDescriptionValue ?? '';
    const trimmedAssistantDescription = typeof normalizedAssistantDescription === 'string'
        ? normalizedAssistantDescription.trim()
        : '';
    const isPublishDisabled = !trimmedAssistantName || !trimmedAssistantDescription;
    const shouldShowPublishDisabledState = showValidationErrors && isPublishDisabled;


    const updateUserList = useCallback((updatedUsers, options = {}) => {
        const safeUsers = Array.isArray(updatedUsers) ? updatedUsers : [];

        setUsers(safeUsers);

        setAssistant(prevState => ({
            ...prevState,
            users: safeUsers,
            ...(options.status !== undefined ? { status: options.status } : {}),
            updated_at: new Date().toISOString().split('T')[0]
        }));

        if (options.status !== undefined) {
            setStatus(options.status);
        }
    }, [setUsers, setAssistant, setStatus]);

    const handlePublishAttempt = useCallback(() => {
        if (isPublishDisabled) {
            triggerValidation && triggerValidation();
            return;
        }

        const normalizedUsers = Array.isArray(users) ? [...users] : [];

        updateUserList(normalizedUsers, { status: true });

        setAlert({
            title: tSelfAssist('publish'),
            type: 'success',
            message: tSelfAssist('publish_success'),
            open: true
        });
    }, [isPublishDisabled, triggerValidation, updateUserList, users, tSelfAssist]);

    const handleUnpublishAttempt = useCallback(() => {
        // When unpublishing, mark status as false locally and show a success alert.
        const normalizedUsers = Array.isArray(users) ? [...users] : [];

        updateUserList(normalizedUsers, { status: false });

        setAlert({
            title: tSelfAssist('unpublish') || 'Unpublish',
            type: 'success',
            message: tSelfAssist('unpublish_success') || 'Assistant taken offline',
            open: true
        });
    }, [updateUserList, users, tSelfAssist]);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const handleExternalPublishAttempt = () => {
            handlePublishAttempt();
        };

        window.addEventListener('assistantPublishAttempt', handleExternalPublishAttempt);

        return () => {
            window.removeEventListener('assistantPublishAttempt', handleExternalPublishAttempt);
        };
    }, [handlePublishAttempt]);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const handleExternalUnpublishAttempt = () => {
            handleUnpublishAttempt();
        };

        window.addEventListener('assistantUnpublishAttempt', handleExternalUnpublishAttempt);

        return () => {
            window.removeEventListener('assistantUnpublishAttempt', handleExternalUnpublishAttempt);
        };
    }, [handleUnpublishAttempt]);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        window.dispatchEvent(new CustomEvent('assistantPublishStateChange', {
            detail: {
                isPublishDisabled,
                shouldShowPublishDisabledState,
                isPublished: Boolean(status)
            }
        }));
    }, [isPublishDisabled, shouldShowPublishDisabledState, status]);


    const debounceTimeout = 1000; // Tempo de debounce (1 segundo)

    // uploadingFilesList removed since upload UI was removed

    useEffect(() => {
        if (svgPath && icons) {
            const matchedIcon = Object.keys(icons).find(key => icons[key]() === svgPath);

            if (matchedIcon) {
                setActiveIcon(matchedIcon);
            }
        }
    }, [svgPath, icons]);

    useEffect(() => {
        if (!accessToken) return;

        const userEmail = typeof email === 'string' ? email : (email?.email || email?.user || '');
        const normalizedEmail = userEmail.trim().toLowerCase();

        const checkFeature = (feature) =>
            fetch(`${process.env.REACT_APP_API_URL}/get_feature_allowed_users?feature=${feature}`, {
                headers: { 'Authorization': `Bearer ${accessToken}` }
            })
                
                .then(r => r.json())
                .then(data => {
                    return (data.allowed_emails || [])
                        .map(e => e.toLowerCase())
                        .includes(normalizedEmail);
                })
                .catch(() => false);

        Promise.all([
            checkFeature('onedrive_selfassistant'),
            checkFeature('n8n_selfassistant'),
        ]).then(([canOneDrive, canN8n]) => {
            setCanUseOneDrive(canOneDrive);
            setCanUseN8n(canN8n);
        });

        console.log('quem pode usar n8n')

        console.log(canUseN8n)
    }, [accessToken, email]);

    // Função para enviar atualização ao backend
    const sendUpdateToBackend = useCallback(() => {
        const name = assistant.assistant.name;
        const description = assistant.assistant.description;

        if (!name || !description || description.length === 0 || description.every(d => d.trim() === '')) {
            console.warn("� necess�rio escrever o nome e a descri��o");
            return;
        }

        if (!isNewCreated) {
            setIsNewCreated(true);
            isCreatingRef.current = true;

            const emailStr = typeof email === 'string' ? email : (email?.email || email?.user || '');

            // Injeta otimisticamente no Hub antes de o backend responder
            const optimisticItem = {
                id: `optimistic-${Date.now()}`,
                type: "self_assistant",
                icon: null,
                nome: name,
                description: Array.isArray(description) ? description : [description],
                adms: [{ email: emailStr }],
                status: false,
            };
            setAssistantList(prev => [...prev, optimisticItem]);

            fetch(`${process.env.REACT_APP_API_URL}/post_assistant`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    email: emailStr,
                    name: name,
                    description: Array.isArray(description) ? description : [description],
                    type: "self_assistant",
                    adms: [{ email: emailStr }],
                }),
            })
                .then(response => response.json())
                .then(data => {
                    const newAssistant = formatAssistantData(data, email);
                    newAssistant.assistant.name = name;
                    newAssistant.assistant.description = Array.isArray(description) ? description : [description];
                    newAssistant.type = "self_assistant";
                    newAssistant.adms = [{ email: emailStr }];

                    const newId = newAssistant._id;

                    // Substitui o item otimístico pelo real.
                    // Se o item real já estiver na lista (fetch do Hub chegou primeiro), apenas remove o otimístico.
                    setAssistantList(prev => {
                        const alreadyExists = prev.some(a => a.id === newId);
                        if (alreadyExists) {
                            return prev.filter(a => a.id !== optimisticItem.id);
                        }
                        return prev.map(a =>
                            a.id === optimisticItem.id
                                ? { ...optimisticItem, id: newId }
                                : a
                        );
                    });

                    isCreatingRef.current = false;
                    setAssistant(newAssistant);
                    setAssistantId(newId);
                })
                .catch(error => {
                    isCreatingRef.current = false;
                    // Remove o item otimístico em caso de erro
                    setAssistantList(prev => prev.filter(a => a.id !== optimisticItem.id));
                    console.error("Erro ao criar novo assistente:", error);
                });
        } else {

            // Edita normalmente se j� foi criado
            fetch(`${process.env.REACT_APP_API_URL}/put_editing_assistant`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    data: assistant
                }),
            })
                .then(response => response.json())
                .then(data => {
                })
                .catch(error => console.error("Erro ao atualizar:", error));
        }
    }, [assistant, isNewCreated, accessToken, email, setIsNewCreated, setAssistant, setAssistantId, setAssistantList]);


    // Hook para monitorar alterações no estado e enviar update ao backend com debounce
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (isCreatingRef.current) return;
            if (assistant.assistant.name && assistant.assistant.description) {
                sendUpdateToBackend();
            }
        }, debounceTimeout);

        return () => clearTimeout(timeoutId);
    }, [assistant, sendUpdateToBackend]);

    useEffect(() => {
        if (activeTab === 'gestao') {
            fetch(`${process.env.REACT_APP_API_URL}/get_list_users`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(response => response.json())
                .then(data => setAllUsers(data))
                .catch(error => console.error("Erro ao buscar usu�rios:", error));
            // Also fetch allowed domains for add-by-email validation (same as AddUserModal)
            fetch(`${process.env.REACT_APP_API_URL}/get_domains`)
                .then(response => response.json())
                .then(data => {
                    const onlyDomains = Array.isArray(data) ? data.map(d => (d.dominio || d).toLowerCase().trim()) : [];
                    setAllowedDomains(onlyDomains);
                })
                .catch(err => console.error("Erro ao buscar dom�nios permitidos:", err));
        }
    }, [activeTab, accessToken]);

    const updateDocumentList = useCallback((newDocuments, action = "add") => {
        const documentsArray = Array.isArray(newDocuments) ? newDocuments : [newDocuments];

        setDocumentList(prevList => {
            let updatedList = prevList;

            if (action === "add") {
                const mergedList = [...prevList];

                documentsArray.forEach(doc => {
                    const exists = mergedList.some(existing => existing.filename === doc.filename);
                    if (!exists) {
                        mergedList.push(doc);
                    }
                });

                updatedList = mergedList;
            } else if (action === "remove") {
                updatedList = prevList.filter(existing =>
                    !documentsArray.some(doc => doc.filename === existing.filename)
                );
            }

            setAssistant(prevState => ({
                ...prevState,
                database: updatedList,
                updated_at: new Date().toISOString().split('T')[0]
            }));

            return updatedList;
        });
    }, [setAssistant, setDocumentList]);

    const uploadToBackend = useCallback(async (filesToUpload) => {
        const filesArray = Array.isArray(filesToUpload) ? filesToUpload : Array.from(filesToUpload || []);
        if (filesArray.length === 0 || !assistantId) return;

        setIsUploading(true);

        const resourcesData = resourceGroup?.reduce((acc, resource) => ({
            search_key: resource?.self_assistant?.search_key ?? acc.search_key,
            endpoint: resource?.self_assistant?.endpoint ?? acc.endpoint,
            index: resource?.self_assistant?.index ?? acc.index,
            openai_endpoint: resource?.self_assistant?.openai_endpoint ?? acc.openai_endpoint,
            openai_key: resource?.self_assistant?.api_key ?? acc.api_key,
            deployment: resource?.self_assistant?.deployment ?? acc.deployment
        }), {
            search_key: null,
            endpoint: null,
            index: null,
            openai_endpoint: null,
            openai_key: null,
            deployment: null
        });

        for (const file of filesArray) {
            const formData = new FormData();
            formData.append('assistant_id', assistantId);
            formData.append('files', file);
            formData.append('resources', JSON.stringify(resourcesData));

            setIsUploading(true);

            try {

                const response = await fetch(`${process.env.REACT_APP_API_URL}/post_documents_selfassistant`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${accessToken}` },
                    body: formData,
                });

                if (!response.ok) {

                    setUploadingFilesList(prev =>
                        prev.filter(prevFile => prevFile.filename !== file.name)
                    );

                    if (response.status === 500) {
                        setAlert({
                            title: tCommon('alertErrorTitle'),
                            type: 'error',
                            message: tSelfAssist('insert_erro'),
                            open: true
                        });
                    } else {
                        // Tarefa 6 (specs/i18n_erros_sistema/plan.md): limite de storage/
                        // assistente não encontrado etc. chegam como error_code - antes
                        // desses 2 status (500) nenhum alerta era mostrado pra outros
                        // erros (413 limite de storage, 404), o usuário só via o arquivo
                        // sumir da lista de upload sem explicação nenhuma.
                        const errorData = await response.json().catch(() => null);
                        if (errorData?.error) {
                            setAlert({
                                title: tCommon('alertErrorTitle'),
                                type: 'error',
                                message: translateBackendError(errorData.error),
                                open: true
                            });
                        }
                    }
                    continue;
                }

                const startData = await response.json();
                const statusUrl = startData.status_url;

                if (!statusUrl) {
                    throw new Error('status_url ausente na resposta');
                }

                // Guarda a pendencia ANTES de aguardar o job: se a pessoa sair da tela, a
                // proxima montagem retoma daqui (ver useEffect de retomada abaixo).
                addPendingUpload(assistantId, { filename: file.name, statusUrl });

                const finalStatus = await pollJobStatus(statusUrl, accessToken, () => mountedRef.current);

                if (!finalStatus) {
                    // Tela desmontada: nao ha onde registrar o arquivo agora. A pendencia
                    // continua guardada e e' resolvida quando a pessoa voltar.
                    continue;
                }

                const docs = finalStatus.docs ?? [];

                if (docs.length > 0) {
                    updateDocumentList(docs);
                    setIsUploading(false);
                } else {
                    // Job terminou sem nenhum documento: nada a registrar, nao retomar de novo.
                    removePendingUpload(assistantId, file.name);
                }

                setUploadingFilesList(prev =>
                    prev.filter(f => f.filename !== file.name)
                );

            } catch (err) {
                console.error('Erro ao enviar arquivo:', err);

                // Job falhou de vez: nao ha o que retomar. Erro de rede/timeout mantem a pendencia.
                if (err?.terminal) {
                    removePendingUpload(assistantId, file.name);
                }

                setUploadingFilesList(prev =>
                    prev.filter(prevFile => prevFile.filename !== file.name)
                );

                setAlert({
                    title: tCommon('alertErrorTitle'),
                    type: 'error',
                    message: tSelfAssist('insert_erro'),
                    open: true
                });
            }
        }

        setIsUploading(false);
        setUploadingFilesList([]);

    }, [accessToken, assistantId, tSelfAssist, updateDocumentList, uploadingFilesList, isUploading]);

    // Retoma uploads que ficaram em andamento quando a pessoa saiu da tela. Roda uma vez
    // por assistente, depois que o `database` dele foi carregado: o que ja esta nele
    // some da lista de pendencias; o resto volta a aparecer como "enviando" e e'
    // acompanhado ate o fim, quando entra na lista pelo caminho de sempre.
    useEffect(() => {
        if (!assistantId || !accessToken) return;
        if (reconciledAssistantRef.current === assistantId) return;
        reconciledAssistantRef.current = assistantId;

        const registered = new Set((documentList || []).map(doc => doc.filename));
        const toResume = [];
        listPendingUploads(assistantId).forEach(entry => {
            if (registered.has(entry.filename)) {
                removePendingUpload(assistantId, entry.filename);
            } else {
                toResume.push(entry);
            }
        });
        if (toResume.length === 0) return;

        setUploadingFilesList(prev => ([
            ...prev,
            ...toResume.map(entry => ({ filename: entry.filename }))
        ]));
        setIsUploading(true);

        (async () => {
            for (const entry of toResume) {
                try {
                    const finalStatus = await pollJobStatus(entry.status_url, accessToken, () => mountedRef.current);

                    if (!finalStatus) return; // saiu de novo: a pendencia continua guardada

                    const docs = finalStatus.docs ?? [];
                    if (docs.length > 0) {
                        updateDocumentList(docs);
                    } else {
                        removePendingUpload(assistantId, entry.filename);
                    }
                } catch (err) {
                    console.error('Erro ao retomar upload pendente:', err);
                    if (err?.terminal) {
                        removePendingUpload(assistantId, entry.filename);
                    }
                    if (mountedRef.current) {
                        setAlert({
                            title: tCommon('alertErrorTitle'),
                            type: 'error',
                            message: tSelfAssist('insert_erro'),
                            open: true
                        });
                    }
                } finally {
                    setUploadingFilesList(prev => prev.filter(f => f.filename !== entry.filename));
                }
            }
            setIsUploading(false);
        })();
    }, [assistantId, accessToken, documentList, updateDocumentList, tCommon, tSelfAssist]);

    const isSecondBoxFilled = useMemo(() => {
        return (
            assistant?.assistant?.name &&
            assistant?.assistant?.description
        );
    }, [assistant]);


    const handleFilesSelected = useCallback((incomingFiles) => {
        if (!isSecondBoxFilled) {
            setTriedUpload(true);
            return;
        }
        const filesArray = Array.isArray(incomingFiles) ? incomingFiles : Array.from(incomingFiles || []);
        if (filesArray.length === 0) {
            return;
        }

        // Always validate that assistant has a name and a description on every upload attempt.
        const name = assistant?.assistant?.name;
        const rawDescription = assistant?.assistant?.description;
        const description = Array.isArray(rawDescription) ? (rawDescription[0] ?? '') : (rawDescription ?? '');

        const nameEmpty = !name || (typeof name === 'string' && name.trim() === '');
        const descriptionEmpty = !description || (typeof description === 'string' && description.trim() === '');

        if (nameEmpty || descriptionEmpty) {
            setAlert({
                title: tCommon('alertErrorTitle'),
                type: 'error',
                message: tSelfAssist('insert_erro'),
                open: true
            });
            return;
        }

        // Keep existing assistantId requirement (assistant must exist on backend to attach docs)
        if (!assistantId) {
            setAlert({
                title: tCommon('alertErrorTitle'),
                type: 'error',
                message: tSelfAssist('insert_erro'),
                open: true
            });
            return;
        }

        setUploadingFilesList(prev => ([
            ...prev,
            ...filesArray.map(file => ({ filename: file.name }))
        ]));

        uploadToBackend(filesArray);
    }, [assistant, assistantId, tSelfAssist, uploadToBackend]);

    const handleDeleteDocument = useCallback((doc) => {

        const resourcesData = resourceGroup?.reduce((acc, resource) => ({
            search_key: resource?.self_assistant?.search_key ?? acc.search_key,
            endpoint: resource?.self_assistant?.endpoint ?? acc.endpoint,
            index: resource?.self_assistant?.index ?? acc.index
        }), {
            search_key: null,
            endpoint: null,
            index: null
        });

        if (!doc) {
            return;
        }

        removePendingUpload(assistantId || assistant?._id, doc.filename);
        updateDocumentList(doc, 'remove');

        fetch(`${process.env.REACT_APP_API_URL}/delete_documents_selfassistant`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                docs: doc,
                assistantId: assistantId || assistant?._id,
                storageUsage: storageUsage,
                resources: resourcesData
            }),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Erro ao deletar: ${response.status}`);
                }
                return response.json();
            })
            .catch(error => {
                console.error('Erro ao remover documento:', error);
                updateDocumentList(doc, 'add');
                setAlert({
                    title: tCommon('alertErrorTitle'),
                    type: 'error',
                    message: tSelfAssist('insert_erro'),
                    open: true
                });
            });
    }, [accessToken, assistantId, tSelfAssist, updateDocumentList]);


    const handleShowDelete = (user) => {
        setUserToDelete(user);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = () => {
        if (!userToDelete) return;

        // Remove localmente
        const updated = Array.isArray(users) ? users.filter(u => u.email !== userToDelete.email) : [];
        updateUserList(updated);

        // Envia atualiza��o para backend (mesma rota usada para salvar assistente)
        fetch(`${process.env.REACT_APP_API_URL}/put_editing_assistant`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`
            },
            body: JSON.stringify({ data: { ...assistant, users: updated } }),
        })
            .then(response => response.json())
            .then(data => {
                // opcional: atualizar estado com a resposta, se necess�rio
                setAssistant(prev => ({ ...prev, users: updated }));
            })
            .catch(error => console.error("Erro ao remover usu�rio:", error));

        // fecha modal
        setShowDeleteModal(false);
        setUserToDelete(null);
    };

    const handleStatus = () => {
        setStatus(prevStatus => {
            const newStatus = !prevStatus;

            setAssistant(prevState => ({
                ...prevState,
                status: newStatus,
                updated_at: new Date().toISOString().split('T')[0]
            }));

            return newStatus;
        });
    };

    // Replaces the previous toggle behavior.
    // The 'Restore' button will call this to restore default advanced parameter values.
    const handleRestoreAdvancedDefaults = () => {
        setAssistant(prev => ({
            ...prev,
            info_model: {
                ...prev.info_model,
                temperature: 0.8,
                n_tokens: 2400,
                top_p: 1,
                frequency_penalty: 0,
                presence_penalty: 0,
            },
            updated_at: new Date().toISOString().split('T')[0]
        }));

        // Ensure the sliders remain visible/active after restoring
        setShowAdvanced(true);

        // No user-facing message required on restore per spec.
    };


    const handleToggleUser = (user) => {
        setUsers(prev => {
            const exists = prev.some(u => u.email === user.email);
            if (exists) {
                return prev.filter(u => u.email !== user.email);
            } else {
                return [...prev, user];
            }
        });
    };

    const handleAddByEmail = useCallback(async (rawValue) => {
        // Prefer value passed directly (from ref) to avoid stale state when clicking quickly
        const candidate = typeof rawValue === 'string' ? rawValue : emailToAdd;
        const email = (candidate || '').trim();
        if (!email) {
            setAlert({ title: tCommon('alertErrorTitle'), type: 'error', message: tSelfAssist('email_required'), open: true });
            return;
        }

        // Basic email validation
        const emailRegex = /^\S+@\S+\.\S+$/;
        if (!emailRegex.test(email)) {
            setAlert({ title: tCommon('alertErrorTitle'), type: 'error', message: tSelfAssist('invalid_email'), open: true });
            return;
        }

        // Domain validation: if allowedDomains loaded, require domain to be allowed
        try {
            const domain = email.split('@')[1].toLowerCase().trim();
            const normalizedDomains = Array.isArray(allowedDomains) ? allowedDomains.map(d => d.toLowerCase().trim()) : [];
            if (normalizedDomains.length > 0 && !normalizedDomains.includes(domain)) {
                setAlert({ title: tCommon('alertErrorTitle'), type: 'error', message: tSelfAssist('dominio_valido'), open: true });
                return;
            }
        } catch (e) {
            // fallback: invalid domain extraction
            setAlert({ title: tCommon('alertErrorTitle'), type: 'error', message: tSelfAssist('dominio_valido'), open: true });
            return;
        }

        // Prevent duplicates: if already present, keep the input value so the user sees it
        const already = Array.isArray(users) && users.some(u => u.email.toLowerCase() === email.toLowerCase());
        if (already) {
            // Do not clear input � leave it as feedback that the email is already added
            return;
        }

        // Create user object (keep shape similar to other user objects)
        const newUser = { email, user: email };
        const updated = Array.isArray(users) ? [...users, newUser] : [newUser];

        // Clear the input immediately when the user submits a new (non-duplicate) email
        setEmailToAdd('');

        // Update local state
        updateUserList(updated);
        setAlert({ title: tCommon('alertSuccessTitle'), type: 'success', message: tSelfAssist('user_added_success'), open: true });

        // Persist change to backend
        try {
            const resp = await fetch(`${process.env.REACT_APP_API_URL}/put_editing_assistant`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ data: { ...assistant, users: updated } })
            });

            if (!resp.ok) {
                throw new Error(`Erro ao adicionar usuário: ${resp.status}`);
            }

            await resp.json();
            // Optionally update assistant state with response
            setAssistant(prev => ({ ...prev, users: updated }));

        } catch (err) {
            console.error('Erro ao adicionar usu�rio:', err);
            // revert local update
            updateUserList(Array.isArray(users) ? users : []);
            setAlert({ title: tCommon('alertErrorTitle'), type: 'error', message: tSelfAssist('user_add_error'), open: true });
        }
    }, [emailToAdd, users, updateUserList, accessToken, assistant, setAssistant, allowedDomains, tSelfAssist]);

    useEffect(() => {
        // Sempre que a lista de usu�rios mudar, mostra o bot�o novamente
        setShowSaveButton(true);
    }, [users]);

    const handleOneDriveFolderSelected = useCallback(async ({ drive_id, folder_id, folder_name }) => {
        // 1) Validar se temos assistantId
        if (!assistantId) {
        setAlert({
            title: tCommon('alertErrorTitle'),
            type: 'error',
            message: tSelfAssist('assistant_id_not_found'),
            open: true,
        });
        return;
        }

        const userEmail =
        typeof email === 'string'
            ? email
            : email?.email || email?.user || '';

        if (!userEmail) {
        setAlert({
            title: tCommon('alertErrorTitle'),
            type: 'error',
            message: tSelfAssist('email_required'),
            open: true,
        });
        return;
        }

        const driveId = drive_id;
        const folderId = folder_id;
        const folderName = folder_name;

        try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/put_onedrive_folder_selfassistant`,
            {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
                assistant_id: assistantId,
                user_email: userEmail.trim().toLowerCase(),
                drive_id: driveId,
                folder_id: folderId,
                folderName: folderName,
            }),
            }
        );

        if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data?.error || `Erro ${response.status}`);
        }

        setAlert({
            title: '',
            type: 'success',
            message: tSelfAssist('onedrive_folder_linked'), 
            open: true,
        });
        } catch (err) {
        console.error('Erro ao vincular pasta OneDrive:', err);
        setAlert({
            title: tCommon('alertErrorTitle'),
            type: 'error',
            message: tSelfAssist('onedrive_folder_error'),
            open: true,
        });
        }
    },
    [assistantId, email, accessToken, tSelfAssist, setAlert]
    );

    const handleReloadOneDriveFolder = useCallback(async () => {
        if (!assistantId) {
            setAlert({
                title: tCommon('alertErrorTitle'),
                type: 'error',
                message: tSelfAssist('assistant_id_not_found'),
                open: true,
            });
            return;
        }

        try {
            const reloadUrl = process.env.REACT_APP_AZURE_FUNCTION_SELFASSISTANT_FOLDER_RELOAD_URL_LOCAL;
            const response = await fetch(reloadUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({ assistant_id: assistantId }),
            });

            if (!response.ok) {
                throw new Error(`Erro ${response.status}`);
            }

            setAlert({
                title: '',
                type: 'success',
                message: tSelfAssist('onedrive_reload_success') || 'Pasta recarregada com sucesso',
                open: true,
            });
        } catch (err) {
            console.error('Erro ao recarregar pasta OneDrive:', err);
            setAlert({
                title: tCommon('alertErrorTitle'),
                type: 'error',
                message: tSelfAssist('onedrive_reload_error') || 'Erro ao recarregar pasta',
                open: true,
            });
        }
    }, [assistantId, accessToken, tSelfAssist]);

    const handleSaveUsers = useCallback(() => {
        if (!assistantId) {
            setAlert({
                title: tCommon('alertErrorTitle'),
                type: 'error',
                message: tSelfAssist('assistant_id_not_found'),
                open: true
            });
            return;
        }

        setShowSaveButton(false);
        setShowAddUsersPanel(false);

        // Envia para o backend em background (fire-and-forget)
        const usersData = Array.isArray(users) ? users.map(user => ({ email: user.email })) : [];

        fetch(`${process.env.REACT_APP_API_URL}/put_update_users`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                assistant_id: assistantId,
                users: usersData
            })
        })
            .then(response => {
                if (!response.ok) {
                    console.error(`Erro ao salvar usu�rios: ${response.status}`);
                }
                return response.json();
            })
            .then(result => {
                // Atualiza o estado com os dados da resposta se dispon�vel
                if (result?.data) {
                    setAssistant(prev => ({ ...prev, users: result.data.users || users }));
                }
                // Esconde o bot�o ap�s salvar

            })
            .catch(error => {
                console.error('Erro ao salvar usu�rios:', error);
                // N�o mostra erro para o usu�rio j� que � background
            });

    }, [assistantId, users, accessToken, setAssistant]);

    return (
        <div>
            {alert.open && (
                <AlertsCustom
                    type={alert.type}
                    title={alert.title}
                    message={alert.message}
                    onClose={() => setAlert(prev => ({ ...prev, open: false }))}
                />
            )}
            {/* Barra de navega��o com 3 abas - deve ficar acima do container principal */}
            <ConfigurationTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                tabs={[
                    {
                        id: 'personalizacao',
                        label: tSelfAssist('personalization_tab'),
                        iconActive: "/imagens/settings.svg",
                        iconInactive: "/imagens/settings-desactived.svg",
                        iconClassName: "icon-setting",
                        disabled: false,
                        iconAlt: "Icon settings"
                    },
                    {
                        id: 'skills',
                        label: tSelfAssist('skills_config_title'),
                        iconActive: "/imagens/skills-btn-blue.svg",
                        iconInactive: "/imagens/skills-btn-gray.svg",
                        iconClassName: "icon-skills",
                        disabled: !assistant.assistant?.name || !assistant.assistant?.description,
                        onDisabledClick: () => {
                            triggerValidation && triggerValidation();
                        },
                        iconAlt: "Icon skills"
                    },
                    {
                        id: 'configuracoes',
                        label: tSelfAssist('advanced_settings_tab'),
                        iconActive: "/imagens/setting-advanced-active.svg",
                        iconInactive: "/imagens/setting-advanced.svg",
                        iconClassName: "icon-advanced-setting",
                        disabled: !assistant.assistant?.name || !assistant.assistant?.description,
                        onDisabledClick: () => {
                            triggerValidation && triggerValidation();
                        },
                        iconAlt: "Icon advanced settings"
                    },
                    {
                        id: 'gestao',
                        label: tSelfAssist('user_management_tab'),
                        iconActive: "/imagens/three-users-active.svg",
                        iconInactive: "/imagens/three-users.svg",
                        iconClassName: "icon-three-users",
                        disabled: !assistant.assistant?.name || !assistant.assistant?.description,
                        onDisabledClick: () => {
                            triggerValidation && triggerValidation();
                        },
                        iconAlt: "Icon three users"
                    }
                ]}
            />


            <div className={`${classeCSS} ${activeTab === 'personalizacao' ? 'tab-1-active' : activeTab === 'gestao' ? 'tab-3-active' : 'tab-2-active'}`}>

                {/* Conte�do exibido apenas quando a aba 'Personaliza��o da IA' estiver ativa */}
                {activeTab === 'personalizacao' && (
                    <>
                        <div className="configuration-panel">
                            <p className="configuration-title-customization">{tSelfAssist('ai_configuration')}</p>
                            <div className='box'>
                                <div className='first-box'>

                                    <div className="modelos-responsive-wrapper">
                                        <Modelos
                                            setModel={(value) => {
                                                handleUpdate("info_model", "model", value);
                                                setModel(value);
                                            }}
                                            defaultModel={model}
                                            width='95%'
                                            shortenGemini={true}
                                            extraModels={
                                                assistant.llm_provider === 'local_cluster' && assistant.local_cluster_config?.model
                                                    ? [{ value: assistant.local_cluster_config.model, label: `${assistant.local_cluster_config.vision_capable } ${assistant.local_cluster_config.model}` }]
                                                    : []
                                            }
                                        />
                                    </div>

                                    <div className='configuration-scroll'>

                                        <p className="configuration-subtitle">{tSelfAssist('ai_image')}</p>

                                        <IconLibrary
                                            icons={icons}
                                            activeIcon={activeIcon}
                                            setActiveIcon={setActiveIcon}
                                            handleUpdate={handleUpdate}
                                            currentIndex={currentIndex}
                                            setCurrentIndex={setCurrentIndex}
                                        />
                                    </div>
                                </div>

                                    <SecondBox
                                        tSelfAssist={tSelfAssist}
                                        showValidationErrors={showValidationErrors}
                                        validationErrors={validationErrors}
                                        assistant={assistant}
                                        handleUpdate={handleUpdate}
                                        normalizedAssistantDescription={normalizedAssistantDescription}
                                    />

                            </div>

                            {/* 'Inserir Instru��es' button removed as requested */}

                            {/* AI parameters section removed as requested */}


                            {/* Upload button removed as requested */}

                            {/* GeneralFileList removed as requested */}

                        </div>
                        <div className="instruction-wrapper">
                            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', position: 'relative' }}>
                                <label className={`configuration-text-instruction`}>{tSelfAssist('instructions_label')}</label>
                                <Info description={tSelfAssist('instructions_info')} />
                            </div>
                            <textarea
                                className={`configuration-instruction-field`}
                                placeholder={tSelfAssist('instruction_placeholder')}
                                value={assistant.assistant.instructions}
                                onChange={(e) => handleUpdate("assistant", "instructions", e.target.value)}
                            />
                            <label className={`configuration-text-capabilities`}>{tSelfAssist('assistant_capabilities')}</label>

                            <div className="web-search-capabilities">
                                <input
                                    type="checkbox"
                                    id="webSearch"
                                    checked={Boolean(assistant.web_search_enabled)}
                                    onChange={(e) => handleCapabilitiesUpdate('web_search_enabled', e.target.checked)}
                                />
                                <label htmlFor="webSearch">{tChat('busca_web')}</label>
                            </div>

                            {canConfigureLocalCluster && (
                                <div className="web-search-capabilities">
                                    <input
                                        type="checkbox"
                                        id="localCluster"
                                        checked={assistant.llm_provider === 'local_cluster'}
                                        onChange={(e) => handleCapabilitiesUpdate('llm_provider', e.target.checked ? 'local_cluster' : 'azure')}
                                    />
                                    <label htmlFor="localCluster">{tSelfAssist('local_cluster_capability_label')}</label>
                                </div>
                            )}

                            {canConfigureLocalCluster && assistant.llm_provider === 'local_cluster' && (
                                <LocalClusterConfig
                                    assistant={assistant}
                                    onUpdate={handleCapabilitiesUpdate}
                                    accessToken={accessToken}
                                />
                            )}

                                {canUseN8n && (
                                    <>
                                        <div className="web-search-capabilities">
                                            <input
                                                type="checkbox"
                                                id="n8nTools"
                                                checked={Boolean(assistant.n8n_tools_enabled)}
                                                onChange={(e) => handleCapabilitiesUpdate('n8n_tools_enabled', e.target.checked)}
                                            />
                                            <label htmlFor="n8nTools">{tSelfAssist('n8n_capability_label')}</label>
                                        </div>

                                        {assistant.n8n_tools_enabled && (
                                            <div className="n8n-capability-area">
                                                <p className="n8n-capability-description">
                                                    {tSelfAssist('n8n_capability_description')}
                                                </p>
                                                <N8nToolsConfig
                                                    assistant={assistant}
                                                    assistantId={assistantId}
                                                    onUpdate={(key, value) => handleCapabilitiesUpdate(key, value)}
                                                    accessToken={accessToken}
                                                />
                                            </div>
                                        )}
                                    </>
                                )}

                        </div>

                            <FileUpload
                                    onFilesSelected={handleFilesSelected}
                                    uploadingFiles={uploadingFilesList}
                                    documentList={documentList}
                                    onDeleteDocument={handleDeleteDocument}
                                    acceptedTypes={['.pdf', '.docx', '.xlsx']}
                                    isUploading={isUploading}
                                    onFolderSelected={handleOneDriveFolderSelected}
                                    assistantId={assistantId}
                                    disabled={!isSecondBoxFilled || !assistantId}
                                    canCreateFolder={canUseOneDrive}
                            />
                        
                            {/* {canUseOneDrive && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <OneDriveFileButton
                                        mode='folder'
                                        onFolderSelected={handleOneDriveFolderSelected}
                                    />
                                    <ReloadFolderButton
                                        onReload={handleReloadOneDriveFolder}
                                        title={tSelfAssist('onedrive_reload') || 'Recarregar pasta OneDrive'}
                                    />
                                </div>
                            )} */}

                    </>
                )}

                {/* Tarefa 1.1 (specs/updated_self_assistant/plan.md): aba "Skills"
                    dedicada - substitui o botao "Gerenciar Skills" que vivia na aba
                    Personalizacao (SkillsManagerModal mode="link" foi removido). */}
                {activeTab === 'skills' && (
                    <SkillsTab email={email} assistantId={assistantId} onCreateSkill={onCreateSkill} />
                )}

                {/* Conte�do exibido na aba 'Configura��es avan�ada': */}
                {activeTab === 'configuracoes' && (
                    <div className={`advanced-settings-painel ${(!assistant.assistant?.name || !assistant.assistant?.description) ? 'section-disabled' : ''}`}>
                        <div className="configuration-header">
                            <p className="configuration-title-advanced">{tSelfAssist('advanced_settings')}</p>
                            <p className="configuration-text-advanced">{tSelfAssist('advanced_text')}</p>
                        </div>
                        <div className="configuration-sub-header">
                            <p className={`configuration-subtitle-advanced-settings ${!showAdvanced ? 'disabled' : ''}`}>{tSelfAssist('ai_parameters')}</p>
                            <div className="custom-toggle-container">
                                <button
                                    type="button"
                                    className={`restore-button`}
                                    onClick={handleRestoreAdvancedDefaults}
                                    aria-label={tSelfAssist('restore') || 'Restaurar'}
                                >
                                    <img
                                        src="/imagens/restore-icon.svg"
                                        alt=""
                                        className="restore-icon"
                                        aria-hidden="true"
                                    />
                                    {tSelfAssist('restore') || 'Restaurar'}
                                </button>
                            </div>
                        </div>

                        {/* Wrapper para aplicar a classe de desabilita��o */}
                        <div className={`tpf-sliders-wrapper ${!showAdvanced ? 'tpf-sliders-disabled' : ''}`}>
                            <TpfSlider
                                title={tSelfAssist('creativity')}
                                maxValue={1}
                                valor={assistant.info_model.temperature}
                                setValor={(value) => handleUpdate("info_model", "temperature", value)}
                                stepType="decimal"
                                description={tSelfAssist('temp_info')}
                            />
                            <TpfSlider
                                title={tSelfAssist('token_number')}
                                minValue={1000}
                                maxValue={12000}
                                valor={assistant.info_model.n_tokens}
                                setValor={(value) => handleUpdate("info_model", "n_tokens", value)}
                                stepType="int"
                                description={tSelfAssist('n_tokens_info')}
                            />
                            <TpfSlider
                                title="Top P"
                                maxValue={1}
                                valor={assistant.info_model.top_p}
                                setValor={(value) => handleUpdate("info_model", "top_p", value)}
                                stepType="decimal"
                                description={tSelfAssist('top_p_info')}
                            />
                            <TpfSlider
                                title={tSelfAssist('frequency_penalty')}
                                maxValue={2}
                                valor={assistant.info_model.frequency_penalty}
                                setValor={(value) => handleUpdate("info_model", "frequency_penalty", value)}
                                stepType="decimal"
                                description={tSelfAssist('frequency_penalty_info')}
                            />
                            <TpfSlider
                                title={tSelfAssist('presence_penalty')}
                                maxValue={2}
                                valor={assistant.info_model.presence_penalty}
                                setValor={(value) => handleUpdate("info_model", "presence_penalty", value)}
                                stepType="decimal"
                                description={tSelfAssist('presence_penalty_info')}
                            />
                        </div>
                    </div>
                )}

                {/* Conte�do exibido na aba 'Gest�o de usu�rios': */}
                {activeTab === 'gestao' && (
                    <div className={`gestao-users-painel ${(!assistant.assistant?.name || !assistant.assistant?.description) ? 'section-disabled' : ''}`}>
                        <div className="configuration-header-gestao">
                            <p className="configuration-title">{tSelfAssist('user_management')}</p>
                        </div>
                        <p className="configuration-subtitle-users">{tSelfAssist('user_management_text')}</p>
                        <div className="usuarios-wrapper-acesso">

                            <div className='assistant-activation'>
                            </div>
                            <div className='user-about owner-section'>
                                <div className='involucro-user'>
                                    <div className="header__user-initial">
                                        {(assistant?.created_by || '').charAt(0).toUpperCase()}
                                    </div>
                                </div>
                                <div className='user-info'>
                                    <p className='user-name'>{assistant?.created_by || tCommon('owner')}</p>
                                    <p className='user-email'>{assistant?.created_by || ''}</p>
                                </div>
                                <div className='user-control'>
                                    <p className='user-level'>{tCommon('owner')}</p>
                                </div>
                            </div>
                            <div className='section-wrapper' data-testid="section-wrapper">
                                <AddUsersButton
                                    label={tSelfAssist('user_adc')}
                                    onClick={() => setShowAddUsersPanel(true)}
                                    data-testid="add-user-button"
                                />
                                <InputAdcWrapper
                                    value={searchTermWithAccess}
                                    onChange={(e) => setSearchTermWithAccess(e.target.value)}
                                    placeholder={tSelfAssist('search_users')}
                                    iconAlt={tSelfAssist('search_icon_alt')}
                                />
                            </div>
                            <div className="self-users-list-wrapper" data-testid="self-users-list-wrapper">
                                <div className="users-list" data-testid="users-list">
                                    {Array.isArray(users) && users.length > 0 && (
                                        /* Ordena users em ordem crescente por nome (ou email) */
                                        [...users]
                                            .filter(u => u?.email && u.email !== (assistant?.created_by || ''))
                                            .filter(user =>
                                                !searchTermWithAccess ||
                                                (user.user || user.email).toLowerCase().includes(searchTermWithAccess.toLowerCase())
                                            )
                                            .sort((a, b) => {
                                                const aName = (a.user || a.email || '').toLowerCase();
                                                const bName = (b.user || b.email || '').toLowerCase();
                                                return aName.localeCompare(bName);
                                            }).map((userItem, index) => (
                                                <div key={`${userItem.email}-${index}`} className='user-about'>
                                                    <div className='involucro-user'>
                                                        <div className="header__user-initial">
                                                            {userItem.email?.charAt(0).toUpperCase()}
                                                        </div>
                                                    </div>
                                                    <div className='user-info'>
                                                        <p className='user-name'>{userItem.user || userItem.email}</p>
                                                        <p className='user-email'>{userItem.email}</p>
                                                    </div>
                                                    <div className='user-control' >
                                                        <img
                                                            src="/imagens/exclude-red.svg"
                                                            alt={tSelfAssist('confirm_delete_user')}
                                                            className="remove-users-icon"
                                                            data-testid="remove-user-icon"
                                                            onClick={() => handleShowDelete(userItem)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </div>
                                                </div>
                                            ))
                                    )}
                                </div>
                            </div>

                        </div>

                        {/* Painel deslizante azul para adicionar usuários */}
                        {showAddUsersPanel && (
                            <div className="usuarios-sem-acesso add-open" role="dialog" aria-label={tSelfAssist('user_adc')}>
                                <div className='add-open-tittle'>
                                    <p className="configuration-title-open">{tSelfAssist('users_adc')}</p>
                                    <img
                                        src="/imagens/x-white.svg"
                                        alt={tCommon('close')}
                                        className="overlay-close"
                                        onClick={() => setShowAddUsersPanel(false)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>

                                <div className="add-wrapper">
                                    <InputAddByEmail
                                        value={emailToAdd}
                                        onChange={(e) => setEmailToAdd(e.target.value)}
                                        onSubmit={() => handleAddByEmail(emailInputRef.current?.value)}
                                        placeholder={tSelfAssist('add_by_email')}
                                        ariaLabel={tSelfAssist('add_by_email')}
                                        wrapperClassName="add-by-email"
                                        inputClassName="input-add-by-email"
                                        iconClassName="add-by-email-icon"
                                        inputRef={emailInputRef}
                                    />

                                    <div className="add-users">
                                        <input
                                            className="input-add-users"
                                            data-testid="input-add-users"
                                            type="text"
                                            placeholder={tSelfAssist('search_users')}
                                            value={searchTermWithoutAccess}
                                            onChange={(e) => setSearchTermWithoutAccess(e.target.value)}
                                        />
                                        <img src="/imagens/search.svg" alt={tSelfAssist('search_icon_alt')} className="add-users-icon" />
                                    </div>
                                </div>

                                <div className="gestao-users-options-list" data-testid='users-options-list'>
                                    {Array.isArray(allUsers) && (
                                        allUsers
                                            .filter(user =>
                                                user.user?.toLowerCase().includes(searchTermWithoutAccess.toLowerCase()) ||
                                                user.email.toLowerCase().includes(searchTermWithoutAccess.toLowerCase())
                                            )
                                            .sort((a, b) => {
                                                const aName = (a.user || a.email || '').toLowerCase();
                                                const bName = (b.user || b.email || '').toLowerCase();
                                                return aName.localeCompare(bName);
                                            })
                                            .map((user, i) => (
                                                <div
                                                    className="gestao-user-option"
                                                    key={i}
                                                    onClick={() => handleToggleUser(user)}

                                                >
                                                    <div className='gestao-involucro-user'>
                                                        <div className="gestao-header-user-initial">
                                                            {user.email.charAt(0).toUpperCase()}
                                                        </div>
                                                    </div>
                                                    <div className='gestao-user-info' data-testid="user-info">
                                                        <p className='gestao-user-name'>{user.user || "Usu�rio sem nome"}</p>
                                                        <p className='gestao-user-email' title={user.email}>
                                                            {user.email && user.email.length > 31 ? `${user.email.slice(0, 31)}...` : user.email}
                                                        </p>
                                                    </div>
                                                    <div className='custom-checkbox' >
                                                        <img

                                                            src={users.some(u => u.email === user.email) ? '/imagens/new-checked.svg' : '/imagens/new-unchecked.svg'}
                                                            alt={users.some(u => u.email === user.email) ? tSelfAssist('selected') : tSelfAssist('not_selected')}
                                                            className="checkbox-image"
                                                            onClick={(e) => { e.stopPropagation(); handleToggleUser(user); }}
                                                            role="button"
                                                            tabIndex={0}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    e.preventDefault();
                                                                    handleToggleUser(user);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            ))
                                    )}
                                </div>

                                
                                    <div className='center-btn-save' data-testid="center-btn-save">
                                        <button className='btn-save-users' onClick={handleSaveUsers}> {tSelfAssist("btn_adc")} </button>
                                    </div>
                                
                            </div>
                        )}
                    </div>
                )}

            </div>
            {/* Modal de confirma��o para remo��o de usu�rio (espec�fico deste m�dulo) */}
            <ConfirmDeleteModal2
                isOpen={showDeleteModal}
                onClose={() => { setShowDeleteModal(false); setUserToDelete(null); }}
                onConfirm={handleConfirmDelete}
                title={tCommon('confirm_delete_user')}
                confirmLabel={tCommon('yes')}
                cancelLabel={tCommon('no')}
            />
        </div>
    );
}

export default ConfigurationModule